import { render, staticRenderFns } from "./SlotView.vue?vue&type=template&id=6e4d9d4a"
import script from "./SlotView.vue?vue&type=script&lang=js"
export * from "./SlotView.vue?vue&type=script&lang=js"
import style0 from "./SlotView.vue?vue&type=style&index=0&id=6e4d9d4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports